import { useQuery } from 'react-query'
import {
  apiGetPlants,
  apiGetPlantByName,
  fetchPlantConfig,
} from '../api/plants'
import { useUserPlant } from './User'
import React from 'react'

export const KEY = 'plants'

export const usePlants = ({ make_model_id, vin }) => {
  const [selectedPlant, setSelectedPlant] = React.useState(null)
  const {
    status,
    data: plants,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    [KEY, make_model_id],
    async () => {
      const result = await apiGetPlants({ make_model_id, vin })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!make_model_id,
      onSuccess: (data) => {
        if (data.length > 0) {
          setSelectedPlant(data[0].name)
        }
      },
    },
  )
  return {
    status,
    plants,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export const useUserPlantInfo = () => {
  const [userPlant] = useUserPlant()
  const {
    status,
    data: plantInfo,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['plant-info', userPlant],
    async () => {
      if (userPlant) {
        const result = await apiGetPlantByName({ plant_name: userPlant })
        return result.data
      }
      return null
    },
    {
      refetchOnWindowFocus: false,
    },
  )
  return {
    status,
    plantInfo,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  }
}

export const useGetPlantConfig = ({ vin_identifier, vin } = {}) => {
  const {
    status,
    data: config,
    error,
    isLoading,
  } = useQuery(
    [KEY, 'config', vin_identifier, vin],
    async () => {
      const result = await fetchPlantConfig({ vin_identifier, vin })
      return result
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!(vin_identifier || vin),
    },
  )
  return { status, config, error, isLoading }
}
